module.exports = __webpack_public_path__ + "img/pdf-image.91c355c1.png";